/**
 * Modules ´Maps´
 */

import {needJquery} from '../../../shared/js/utils/index';
import Manipulator from "../../../shared/js/dom/manipulator";

// -------
// Private
// -------

const $ = needJquery();

const init = (o = {}) => {
	var mapInit,
		mapSetup,
		mapIObserver,
		customProperties,
		getInlineConfig = function(el, t) {
			var cfg  = {},
				s    = (t !== 'undefined' && t !== '') ? 'data-config="' + t + '"' : 'data-config',
				$cfg = el.find('> script[type="application/json"][' + s + ']').eq(0);

			if ($cfg.length > 0) {
				cfg = JSON.parse($cfg.text()) || {};

				$cfg.remove();
			}

			return cfg;
		};

	if(window.hasOwnProperty( "ifabMapPoints" ))
	{
		customProperties = ifabMapPoints;
	}

	mapInit = function($map, params) {
		var options = params ? params : {
				'map' : {
					'provider' : 'openstreetmap',
					'osm' : {
						// 'tileProvider' : 'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png'
						'tileProvider' : 'https://tile.openstreetmap.de/{z}/{x}/{y}.png'
					},
					'default' : {
						'show': 0,
						'zoom' : 18,
						'marker': {
							'lat': 50,
							'lon': 11,
							'color': '#000',
							'size' : ["25", "25"]
						}
					},
					'onInitialized': null
				}
			},
			$mapContainer = $map.closest('.mapView')[0],
			$mapNative,
			$mapLegend,
			$mapLegendMarker,
			mapInstance,
			mapLayer,
			$Marker,
			markerCoord;

		if ($map.length <= 0) {
			return;
		}

		$mapNative = $map[0];
		mapInstance = L.map($mapNative, {zoomSnap : 2});

		mapInstance
			.on('popupopen', function(e) {
				mapInstance['_panes']['tilePane'].classList.add('-blurred');
			})
			.on('popupclose', function(e) {
				mapInstance['_panes']['tilePane'].classList.remove('-blurred');
			});

		// Hover-Effekt Karten-Legende
		if($mapContainer.querySelector('.mapView__map-legend')) {
			$mapLegend       = $mapContainer.querySelector('.mapView__map-legend');
			$mapLegendMarker = $mapLegend.getElementsByClassName('mapView__map-marker');

			for (var i = 0; i < $mapLegendMarker.length; i++) {
				$mapLegendMarker[i].addEventListener('mouseenter', function(e) {
					$Marker     = e.target;
					markerCoord = $Marker.getAttribute('data-coord-trigger');

					if(!$mapContainer.classList.contains('-is-waiting')) {
						$mapContainer.querySelector('[data-coord-target="' + markerCoord + '"]').classList.add('-hover');
					}
				});

				$mapLegendMarker[i].addEventListener('mouseleave', function(e) {
					$Marker     = e.target;
					markerCoord = $Marker.getAttribute('data-coord-trigger');

					if(!$mapContainer.classList.contains('-is-waiting')) {
						$mapContainer.querySelector('[data-coord-target="' + markerCoord + '"]').classList.remove('-hover');
					}
				});

				$mapLegendMarker[i].addEventListener('click', function(e) {
					$Marker     = this;
					markerCoord = $Marker.getAttribute('data-coord-trigger');

					if(!$mapContainer.classList.contains('-is-waiting')) {
						// console.log($mapContainer.querySelector('[data-coord-target="' + markerCoord + '"]').parentNode);
						$mapContainer.querySelector('[data-coord-target="' + markerCoord + '"]').parentNode.click();
					}
				});
			}
		}

		// Layer initialisieren.
		switch (options.map.provider) {
			case 'googlemaps':
				if (typeof google === 'object' && typeof google.maps === 'object') {
					mapLayer = L.gridLayer.googleMutant({
						type: "roadmap", // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
					});
				} else {
					let tileLayerProvider = options.map.osm.tileProvider ? options.map.osm.tileProvider : 'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png';

					mapLayer = L.tileLayer(tileLayerProvider, {
						attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
					});

					console.log('You did not include the Googlemaps-Api correctly. So we loaded the free OpenStreetMap-Config for you.');
				}
				mapLayer.addTo(mapInstance);
				break;
			default:
				let tileLayerProvider = options.map.osm.tileProvider ? options.map.osm.tileProvider : 'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png';

				mapLayer = L.tileLayer(tileLayerProvider, {
					attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
				});
				mapLayer.addTo(mapInstance);
				break;
		}

		setTimeout(function() {
			$map.data('map.initialized', true);

			// // Klick-Event.
			if (typeof options.map.onInitialized === 'function') {
				options.map.onInitialized(mapInstance, L);
			}

			// $mapContainer.removeClass('-is-waiting');
			$mapContainer.classList.remove('-is-waiting');

			return mapInstance;
		}, 1000);
	};

	/**
	 * Initialisierung und Handling der Map.
	 * Wird vom (Map)Observer bei Erfolg gestartet!
	 */
	mapSetup = function($this) {
		var $mapContainer = $this,
			$map          = $mapContainer.find('.ifabmaps__map-viewer'),
			$mapInfo      = $mapContainer.find('.ifab-location-map-info'),
			mapInstance,
			customParams = getInlineConfig($mapContainer, 'map'),
			options = customParams,
			bounds = [],
			defaultMarker = {},
			customMarker,
			point,
			icon;

		// Abbruch wenn benötigte Elemente fehlen.
		if (
			$mapContainer.length <= 0
		) {
			return;
		}

		// Container einblenden
		$mapContainer.css('display', 'block');

		// Wurde die Map schon initialisiert?
		if ($mapContainer.data('map.initialized') === true) {
			if ($mapInfo.length) {
				$mapInfo.hide(0);
			}

			$map[0].scrollIntoView({
				behavior: 'smooth',
				block   : 'start'
			});

			return;
		}

		// Aktuelle Parameter für Default-Marker
		defaultMarker = {
			lat  : customParams.map.default.marker.lat ? parseFloat(customParams.map.default.marker.lat) : 50,
			lon  : customParams.map.default.marker.lon ? parseFloat(customParams.map.default.marker.lon) : 11,
			size : customParams.map.default.marker.size ? customParams.map.default.marker.size : [21, 21],
			color: customParams.map.default.marker.color ? customParams.map.default.marker.color : '#000',
			zoom : customParams.map.default.zoom ? customParams.map.default.zoom : 18,
			show : customParams.map.default.show ? customParams.map.default.show : 0
		};

		options.map.onInitialized = function(map, l) {
			var
				i = 0,
				prop,
				getBounds,
				markerClusters = L.markerClusterGroup();

			//Default Marker anzeigen?
			if(defaultMarker.show) {
				defaultMarker.Point = new l.marker([defaultMarker.lat, defaultMarker.lon]);

				// HTML-Icon für Marker hinterlegen
				defaultMarker.Icon = new L.divIcon({
					className: '',
					html: '<div class="leaflet-default-icon"><span class="leaflet-default-icon__inner" style="background-color:' + defaultMarker.color + '"></span></div>',
					iconSize: defaultMarker.size// size of the icon
				});

				map.addLayer(defaultMarker.Point);
				defaultMarker.Point.setIcon(defaultMarker.Icon);
			}

			for (prop in customParams.map.custom) {
				let header,
					body,
					image,
					popupEl = Manipulator.createElementFrom('<div class="popup"/>')

				customMarker = customParams.map.custom[prop];

				// Point anlegen
				point = new l.marker([customMarker.marker.lat, customMarker.marker.lon]);
				bounds[i] = point;
				i++;

				// Popup erstellen
				customMarker.dataPopup = '-with-popup';
				header   = '<header class="popup__header"><h6>' + customMarker.marker.name + '</h6></header>';

				Manipulator.elementAppend(header, popupEl);

				if(customMarker.marker.address || customMarker.marker.power || customMarker.marker.text) {
					 body = Manipulator.createElementFrom('<div class="popup__body"/>');

					if(customMarker.marker.address) {
						Manipulator.elementAppend(`<div class="address"><p><i class="fas fa-map-marker"></i> ${customMarker.marker.address}</p></div>`, body);
					}

					if(customMarker.marker.power) {
						Manipulator.elementAppend(`<div class="power"><p><i class="fas fa-bolt"></i> ${customMarker.marker.power}</p></div>`, body);
					}
					if(customMarker.marker.text) {
						Manipulator.elementAppend(`<div class="info"><p>${customMarker.marker.text}</p></div>`, body);
					}

					Manipulator.elementAppend(body, popupEl);
				}

				if(customMarker.marker.image && customMarker.marker.image !== "0") {
					image = Manipulator.createElementFrom(`<div class="popup__image"><figure class="figure"><picure>${decodeURIComponent(customMarker.marker.image)}</picure></figure></div>`);

					Manipulator.elementAppend(image, popupEl);
				}

				let popup = L.popup()
					.setContent(popupEl);

				point.bindPopup(popup);

				// HTML-Icon für Marker hinterlegen
				icon = new L.divIcon({
					className: customMarker.dataPopup,
					html: '<div class="leaflet-custom-icon" data-coord-target="' + customMarker.marker.lat + '/' + customMarker.marker.lon + '"><span class="leaflet-custom-icon__inner" style="background-color:' + customMarker.marker.color + '"></span></div>',
					iconSize: customMarker.marker.size// size of the icon
				});

				markerClusters.addLayer(point);
				// map.addLayer(point);
				map.addLayer(markerClusters);
				point.setIcon(icon);
			}

			if(Object.keys(customParams.map.custom).length > 1) {
				getBounds = new L.featureGroup(bounds);
				map.fitBounds(getBounds.getBounds());
			} else {
				// Map zentrieren.
				map.setView(bounds[0]['_latlng'], customParams.map.default.zoom);
			}
		};

		// Map initialisieren.
		mapInstance = mapInit($map, options);
	};

	// falls ein Map-HTML-Objekt existiert,
	// initiiere für jedes vorhandene Objekt die Kartenfunktion
	if($('.mapView').length > 0) {
		$('.mapView').each(function() {
			mapSetup($(this));
		});
	}
};

// ------
// Public
// ------

// Export
export default {
	init : init
};
